const IDCardSkeletonLoader = () => {
  return (
    <div className="mx-auto h-full w-[70%] animate-pulse rounded-lg border border-gray-300 bg-white p-6 shadow">
      {Array.from({ length: 2 }).map((_, idx) => (
        <div
          key={idx}
          className="mx-auto w-full animate-pulse rounded-lg border border-gray-300 bg-white p-6 shadow"
        >
          <div className="mb-4 h-6 w-1/3 rounded bg-gray-300" />
          <div className="mb-3 h-4 w-1/2 rounded bg-gray-300" />
          <div className="mb-3 h-5 w-3/4 rounded bg-gray-300" />
          <div className="space-y-2">
            <div className="h-3 w-full rounded bg-gray-300" />
            <div className="h-3 w-5/6 rounded bg-gray-300" />
            <div className="h-3 w-4/6 rounded bg-gray-300" />
            <div className="h-3 w-2/3 rounded bg-gray-300" />
          </div>
          <div className="mt-6 h-5 w-1/4 rounded bg-gray-300" />
        </div>
      ))}
    </div>
  );
};

export default IDCardSkeletonLoader;
